import React, { useContext, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { SlSizeFullscreen } from "react-icons/sl";
import { MdFullscreenExit } from "react-icons/md";
import { LoginContext } from "../../../../App";

function CustomCard({ style, minHeight, header, children, id }) {
  const { theme, fullScreen, setFullScreen } = useContext(LoginContext);
  const cardRef = useRef(null);

  // Determine text color based on theme
  const textColor = theme === "dark" ? "#ffffff" : "#000000";
  const backgroundColor = theme === "dark" ? "#000000" : "#ffffff";

  useEffect(() => {
    const handleFullScreenChange = () => {
      setFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullScreenChange);
    document.addEventListener("msfullscreenchange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullScreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullScreenChange
      );
    };
  }, [setFullScreen]);

  const toggleFullScreen = () => {
    const element = cardRef.current;
    if (element) {
      if (!document.fullscreenElement) {
        setFullScreen(true);
        if (element.requestFullscreen) {
          element.requestFullscreen().catch((err) => {
            console.error(`Error enabling full-screen mode: ${err.message}`);
          });
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        setFullScreen(false);
      }
    }
  };

  return (
    <Card
      ref={cardRef}
      className="bg-chart"
      style={{
        height: style,
        minHeight: minHeight,
        backgroundColor: fullScreen ? backgroundColor : undefined,
        color: textColor,
      }}
    >
      {header && (
        <Card.Header
          className="d-flex justify-content-between pd-2"
          style={{ color: textColor }}
        >
          <span>{header}</span>

          {id && (
            <span>
              <Button
                data-tooltip-id="fullscreen-button"
                className="delete edit fullscreen-button"
                style={{
                  background: backgroundColor,
                  color: textColor,
                }}
                onClick={toggleFullScreen}
              >
                {fullScreen ? <MdFullscreenExit /> : <SlSizeFullscreen />}
              </Button>
            </span>
          )}
        </Card.Header>
      )}
      <Card.Body
        className="overflow-auto mh-auto"
        style={{
          backgroundColor: fullScreen ? backgroundColor : undefined,
          color: textColor,
        }}
      >
        {children}
      </Card.Body>
    </Card>
  );
}

export default CustomCard;
